import React, { useState } from 'react';

// Shows a freshly issued temporary password. Fixed to the top-right of the viewport so it is
// visible wherever the admin has scrolled (the people list is long), and stays until closed.
export default function TempPasswordNotice({ issued, onClose }) {
  const [copied, setCopied] = useState(false);
  if (!issued) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(issued.temporaryPassword);
      setCopied(true);
    } catch { /* clipboard unavailable: the password is selectable */ }
  };

  return (
    <div role="status" className="fixed top-4 right-4 z-50 w-96 max-w-[calc(100vw-2rem)] border-2 border-yellow-500 bg-yellow-50 text-yellow-900 rounded-lg shadow-2xl p-4">
      <p className="text-sm">Username: <strong className="select-all">{issued.username}</strong></p>
      <p className="text-sm mt-1">Temporary password:</p>
      <code className="block font-mono font-bold text-lg select-all bg-white border border-yellow-300 rounded px-2 py-1 mt-1">
        {issued.temporaryPassword}
      </code>
      <p className="text-xs mt-2">
        Shown only once. The user must change it at first sign-in.
      </p>
      <div className="mt-3 flex gap-2">
        <button onClick={copy} className="bg-yellow-600 text-white text-sm px-3 py-1 rounded hover:bg-yellow-700">
          {copied ? 'Copied' : 'Copy password'}
        </button>
        <button onClick={onClose} className="bg-gray-200 text-black text-sm px-3 py-1 rounded hover:bg-gray-300">Close</button>
      </div>
    </div>
  );
}
